export default class HealthSystem {
    constructor (dto) {
        this.name = '';
        this.type = 0;
        this.status = 0;
        this.statusName = '';
        this.autoImportsStatus = [];

        if (dto) {
            this.name = dto.Name;
            this.type = dto.Type;
            this.status = dto.Status;
            this.statusName = dto.StatusName.toLowerCase();
            this.autoImportsStatus = dto.AutoImportsStatus;
        }
    }

    toDto () {
        return {
            Name: this.name,
            Type: this.type,
            Status: this.status,
            StatusName: this.statusName,
            AutoImportsStatus: this.autoImportsStatus
        };
    }
}